<script>
	import { getContext, onDestroy, onMount } from 'svelte'
	import GRS from '../components/GRS.svelte';
	import GrsDevices from './grsDevices';
	import * as map from '../map'

	const flightContext = getContext('flight')
	let flight
	let markers
	let grsDevices

	let layer
	let overlay
	onMount(() => {
		flight = flightContext.get()
		layer = L.layerGroup()
		layer.addTo(map.getMap())
		overlay = map.addOverlay("GRS", layer, flight.overlay)

		grsDevices = flight.getHandler(GrsDevices)
		markers = grsDevices.store
	})

	onDestroy(() => {
		layer.removeFrom(map.getMap())
		map.removeOverlay(overlay, flight.overlay)
		flight.releaseHandler(GrsDevices)
	})
</script>

{#each Object.values($markers ?? {}).filter(m => m.type == 'GRS') as device (device.id)}
	<GRS active {device} {layer} />
{/each}
